import { render, staticRenderFns } from "./teste_form_render.vue?vue&type=template&id=46d9d2d0&"
import script from "./teste_form_render.vue?vue&type=script&lang=js&"
export * from "./teste_form_render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d9d2d0')) {
      api.createRecord('46d9d2d0', component.options)
    } else {
      api.reload('46d9d2d0', component.options)
    }
    module.hot.accept("./teste_form_render.vue?vue&type=template&id=46d9d2d0&", function () {
      api.rerender('46d9d2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/teste_form_render.vue"
export default component.exports